// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"68383aefdedeb84412e8","966":"d8409feb7cfa6dd334fd"}[chunkId] + ".js";
};